<template>
  <!-- 周报查看 -->
  <el-dialog v-dialogDrag title="周报" :visible.sync="dialogSeeShow" width="44%" top="4vh" class="dialogSeeWeekly" :close-on-click-modal="false"
    :close-on-press-escape="false" @open="beforeOpen" @close="reset">
    <div class="titleRow">
      <el-divider direction="vertical"></el-divider>
      <span>发起人信息</span>
    </div>
    <!-- 发起人信息表单 -->
    <el-form ref="sponsorForm" class="sponsorForm" label-width="156px" size="small">
      <el-row>
        <el-col :span="12">
          <el-form-item label="项目名称">
            <el-tooltip effect="dark" :value="toolTips.tip1" :content="reportDetails.prjName" placement="top-end">
              <span @click="toolTips.tip1 = !toolTips.tip1">{{ reportDetails.prjName }}</span>
            </el-tooltip>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="编号" class="rightItem">
            <el-tooltip effect="dark" :value="toolTips.tip2" :content="reportDetails.formNo" placement="top-end">
              <span @click="toolTips.tip2 = !toolTips.tip2">{{ reportDetails.formNo }}</span>
            </el-tooltip>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="管理记录人">
            <el-tooltip effect="dark" :value="toolTips.tip3" :content="reportDetails.createUserName"
              placement="top-end">
              <span @click="toolTips.tip3 = !toolTips.tip3">{{ reportDetails.createUserName }}</span>
            </el-tooltip>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="时间" class="rightItem">
            <el-tooltip effect="dark" :value="toolTips.tip4"
              :content="reportDetails.reportStartDate + ' 至 ' + reportDetails.reportEndDate" placement="top-end">
              <span @click="toolTips.tip4 = !toolTips.tip4">
                {{ reportDetails.reportStartDate + ' 至 ' + reportDetails.reportEndDate }}
              </span>
            </el-tooltip>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="设计单位">
            <el-tooltip effect="dark" :value="toolTips.tip5" :content="reportDetails.designEnterprise"
              placement="top-end">
              <span @click="toolTips.tip5 = !toolTips.tip5">{{ reportDetails.designEnterprise }}</span>
            </el-tooltip>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="地点" class="rightItem">
            <el-tooltip effect="dark" :value="toolTips.tip6" :content="reportDetails.place" placement="top-end">
              <span @click="toolTips.tip6 = !toolTips.tip6">{{ reportDetails.place }}</span>
            </el-tooltip>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="驻场设计管理人员">
            <el-tooltip effect="dark" :value="toolTips.tip7" :content="reportDetails.designManagePersonnel"
              placement="top-end">
              <span @click="toolTips.tip7 = !toolTips.tip7">{{ reportDetails.designManagePersonnel }}</span>
            </el-tooltip>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div class="titleRow">
      <el-divider direction="vertical"></el-divider>
      <span>工作完成情况</span>
    </div>
    <!-- 工作完成情况表单 -->
    <el-form ref="workForm" size="small" class="workForm" label-width="156px">
      <el-form-item label="设计管理内容">
        <el-input v-model="reportDetails.designManageContent" type="textarea" placeholder="" resize="none" readonly>
        </el-input>
      </el-form-item>
      <el-form-item label="目前进度情况及要求">
        <el-input v-model="reportDetails.currentProgress " type="textarea" placeholder="" resize="none" readonly>
        </el-input>
      </el-form-item>
      <el-form-item label="项目需求">
        <el-input v-model="reportDetails.projectRequirement" type="textarea" placeholder="" resize="none" readonly>
        </el-input>
      </el-form-item>
      <el-form-item label="存在问题">
        <el-input v-model="reportDetails.existingProblems" type="textarea" placeholder="" resize="none" readonly>
        </el-input>
      </el-form-item>
      <el-form-item label="下一个计划">
        <el-input v-model="reportDetails.nextStepPlan" type="textarea" placeholder="" resize="none" readonly></el-input>
      </el-form-item>
      <el-form-item label="相关附件" class="enclosure">
        <div class="files">
          <el-tag v-for="file in reportDetails.files" :key="file.fileId" @click="preview(file)">
            {{ file.fileName }}
            <i class="el-icon-download" @click.stop="download(file.fileId)"></i>
          </el-tag>
        </div>
      </el-form-item>
    </el-form>

    <div class="titleRow">
      <el-divider direction="vertical"></el-divider>
      <span>发送信息</span>
    </div>
    <!-- 接收人 -->
    <div class="receiver">
      <div v-for="person in reportDetails.users" :key="person.userId" class="onePerson">
        <el-image v-if="person.isRead" :src="isReadSrc" class="isReadImg"></el-image>
        <div class="avatortox">{{ tox(person.name) }}</div>
        <span>{{ person.name }}</span>
      </div>
    </div>

    <div class="titleRow">
      <el-divider direction="vertical"></el-divider>
      <span>评论</span>
    </div>
    <!-- 评论列表 -->
    <div class="commentList">
      <div v-for="item in commentList" :key="item.cmntId" class="commentItem">
        <div class="comment">
          <div class="avatortox">{{ tox(item.createUserName) }}</div>
          <div class="commentUp">
            <span class="title">{{ item.title }}</span>
            <span class="date">{{ item.createDate }}</span>
          </div>
          <div class="commentDown">
            {{ item.content }}
          </div>
        </div>
        <el-image v-if="canReply(item.createUserId)" class="reply" :src="replySrc" @click="setParentId(item)">
        </el-image>
      </div>
    </div>

    <!-- 底部: 发表评论区 -->
    <span v-if="canComment" slot="footer" class="newComment">
      <el-input v-model="newComment" type="textarea" :placeholder="placeholder" resize="none" :maxlength="200">
      </el-input>
      <el-button v-if="!parentId" size="small" type="primary" :disabled="!newComment.trim()" @click="addComment">评论
      </el-button>
      <el-button v-if="parentId" size="small" type="primary" :disabled="!newComment.trim()" @click="addComment">回复
      </el-button>
    </span>
    <div v-if="!canComment" slot="footer" class="closeBtn">
      <el-button size="small" @click="dialogSeeShow = false">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import weeklyService from "@/CommonDP/service/weekly-service";
import { mapState } from "vuex";
import { downloadUrltoken } from "@/CommonDP/utils";
import { filePreviewV1 } from "@/CommonDP/utils/docPublic";

export default {
  components: {},
  props: {
    reportId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      addReceiver: require("@/CommonDP/assets/weekly/addReceiver.png"), // 图片--添加接收人
      isReadSrc: require("@/CommonDP/assets/weekly/isRead.png"), // 图片--已读
      replySrc: require("@/CommonDP/assets/weekly/reply.png"), // 图片--回复

      dialogSeeShow: false, // 查看弹框
      reportDetails: {}, // 周报详情数据
      commentList: [], // 评论列表
      newComment: "", // 新评论
      parentId: "", // 回复的评论id
      placeholder: "请输入评论内容", // 回复的评论内容

      // 文字提示,手动点击
      toolTips: {
        tip1: false,
        tip2: false,
        tip3: false,
        tip4: false,
        tip5: false,
        tip6: false,
        tip7: false
      }
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo
    }),

    // 能否评论
    canComment() {
      if (this.userInfo.userId === this.reportDetails.createUserId) {
        if (this.parentId) return true;
        else return false;
      } else {
        return true;
      }
    }
  },
  methods: {
    // 打开前
    beforeOpen() {
      this.getReportDetails().then(() => {
        this.getCommentList();
        this.$emit("refreshList");
      });
    },

    // 离开时，重置
    reset() {
      this.newComment = "";
      this.parentId = "";
      this.placeholder = "请输入评论内容";
      this.toolTips = {
        tip1: false,
        tip2: false,
        tip3: false,
        tip4: false,
        tip5: false,
        tip6: false,
        tip7: false
      };
    },

    // 获得详情
    async getReportDetails() {
      const res = await weeklyService.getReportDetails(this.reportId);
      this.reportDetails = res.data;
    },

    // 根据关联id查询评论
    async getCommentList() {
      const params = {
        prjId: this.reportDetails.prjId,
        relaId: this.reportDetails.reportId
      };
      const res = await weeklyService.getCommentList(params);
      this.commentList = res.data;
    },

    // 设置回复评论id
    setParentId(item) {
      if (this.parentId !== item.cmntId) {
        this.parentId = item.cmntId;
        this.placeholder = "回复 " + item.content;
      } else {
        this.parentId = "";
        this.placeholder = "请输入评论内容";
      }
    },

    // 添加评论
    async addComment() {
      const params = {
        content: this.newComment,
        prjId: this.reportDetails.prjId,
        relaId: this.reportDetails.reportId,
        typeId: 2,
        parentId: this.parentId
      };
      await weeklyService.addComment(params);
      this.newComment = "";
      this.parentId = "";
      this.placeholder = "请输入评论内容";
      this.getCommentList();
    },

    // 可以回复
    canReply(userId) {
      if (this.userInfo.userId !== userId) return true;
      else return false;
    },

    // 附件预览
    preview(file) {
      const { status, fileId, fileVersion: versionId = 1, parentId, fileType } = file;
      const data = { status, fileId, versionId, parentId, fileType };
      filePreviewV1(data, this.reportDetails.files);
    },
    // 附件下载
    download(fileId) {
      window.location = downloadUrltoken("EnterpriseDoc", fileId);
    },

    // 姓
    tox(name) {
      return name ? name.charAt(0) : "";
    }
  }
};
</script>

<style lang='scss' scoped>
.titleRow {
  width: 100%;
  display: flex;
  align-items: center;

  .el-divider {
    background-color: var(--theme-color);
    width: 3px;
    height: 15px;
    margin: 0 8px 0 0;
  }

  span {
    font-family: "PingFang SC";
    font-size: 14px;
    font-weight: 400;
    color: var(--key-color);
    white-space: nowrap;
  }
}

.sponsorForm {
  margin: 10px 0;
  border-top: 1px solid #dee6f7;

  .el-form-item {
    margin: 0;

    span {
      display: block;
      padding: 0 5px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    /deep/ .el-form-item__label {
      padding: 0;
      border: 1px solid #dee6f7;
      border-top: 0;
      background: #f8fafe;
      text-align: center;
      font-weight: 500;
      color: var(--key-color);
    }

    /deep/ .el-form-item__content {
      height: 33px;
      border: 1px solid #dee6f7;
      border-left: 0;
      border-top: 0;
      text-align: center;
      font-size: 14px;
      color: var(--key-color);

      .el-form-item__error {
        top: 22px;
        width: 100%;
        text-align: center;
        white-space: nowrap;
      }
    }

    /deep/.el-input__inner {
      border: none;
      text-align: center;
    }
  }

  .rightItem {
    /deep/ .el-form-item__label {
      border-left: 0;
    }
  }
}

.workForm {
  margin: 10px 0;
  border-top: 1px solid #dee6f7;

  .el-form-item {
    margin: 0;

    /deep/ .el-form-item__label {
      line-height: 65px;
      padding: 0;
      border: 1px solid #dee6f7;
      border-top: 0;
      background: #f8fafe;
      text-align: center;
      font-weight: 500;
      color: var(--key-color);
    }

    /deep/ .el-form-item__content {
      padding: 10px 10px 0;
      height: 66px;
      border: 1px solid #dee6f7;
      border-left: 0;
      border-top: 0;
      text-align: center;
      font-size: 14px;
      color: var(--key-color);

      .el-form-item__error {
        top: 33px;
        width: 100%;
        text-align: center;
        white-space: nowrap;
      }
    }

    /deep/ .el-textarea__inner {
      height: 45px !important;
    }
  }

  .enclosure {
    /deep/ .el-form-item__content {
      text-align: start;
    }

    .files {
      width: 100%;
      height: 45px;
      display: flex;
      align-items: center;
      flex-flow: wrap;
      overflow-y: auto;

      .el-button {
        margin-right: 20px;
      }

      .el-tag {
        margin: 5px 10px 5px 0;
        padding-right: 0;
        cursor: pointer;

        i {
          padding: 10px;
          margin-left: 0;
        }
      }
    }
  }
}

.receiver {
  width: 100%;
  padding: 15px 10px 20px;
  display: flex;
  flex-flow: wrap;

  .onePerson {
    margin: 5px 30px 5px 0;
    position: relative;

    white-space: nowrap;
    display: flex;
    align-items: center;

    span {
      margin-left: 10px;
      font-family: "PingFang SC";
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: var(--key-color);
      white-space: nowrap;
    }

    .isReadImg {
      width: 16px;
      height: 16px;
      position: absolute;
      top: -6px;
      left: 20px;
    }
  }
}

.commentList {
  width: 100%;
  margin: 10px 0;
  max-height: 330px;
  overflow-y: auto;

  .commentItem {
    width: 100%;
    padding: 10px 0 10px 20px;
    border-bottom: 1px solid #ebefff;
    display: flex;

    .comment {
      width: 1px;
      flex-grow: 1;

      .commentUp {
        padding: 5px;

        .title {
          font-family: "PingFang SC";
          font-weight: 400;
          font-size: 16px;
          line-height: 22px;
          color: var(--key-color);
          margin-right: 20px;
        }

        .date {
          font-family: "PingFang SC";
          font-weight: 400;
          font-size: 14px;
          line-height: 22px;
          color: var(--info-color)9;
        }
      }

      .commentDown {
        padding: 5px;
        white-space: pre-wrap;
        font-family: "PingFang SC";
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #222d48;
      }
    }

    .reply {
      width: 18px;
      height: 18px;
      margin: 20px;
      cursor: pointer;
    }
  }
}

.newComment {
  /deep/ .el-textarea__inner {
    height: 90px !important;
    margin: 15px 0;
    background-color: rgba(242, 245, 255, 0.76) !important;
  }
}

.closeBtn {
  width: 100%;
  text-align: center;

  .el-button {
    width: 100px;
  }
}

.avatortox {
  border-radius: 50%;
  width: 32px;
  height: 32px;
  line-height: 30px;
  margin: 0 auto;
  margin-top: 0px;
  border: 1px solid #4777e7;
  background: #4777e7;
  color: #fff;
  display: inline-block;
  vertical-align: top;
  text-align: center;
}
</style>

<style lang='scss'>
.dialogSeeWeekly {
  .el-dialog {
    border-radius: 4px !important;
  }

  .el-dialog__header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .el-dialog__title {
      font-family: "PingFang SC";
      font-weight: 700;
      font-size: 18px;
      line-height: 25px;
      color: var(--key-color);
    }

    .el-dialog__headerbtn {
      position: relative;
      top: 0 !important;
      right: 0 !important;
    }
  }

  .el-dialog__body {
    padding: 10px 20px !important;
    border-bottom: 0 !important;
  }

  .el-dialog__footer {
    border-top: 15px solid #f4f5fa;
    padding: 10px 30px 15px !important;
  }
}
</style>
